/**
 * 验证码验证返回结果结构
 */
export class VerificationCodeResult {
  /**
   * 是否通过
   */
  pass = false
  /**
   * 通过后,返回的token
   */
  token: string
}
